// ConfirmModal.jsx
import React from "react";
import { Modal, ModalBody } from "reactstrap";
import CloudStorage from "../../CloudStorage/CloudStorage";
import { useSelector } from "react-redux";

export default function ConfirmModal({
  isOpen,
  toggle,
  title = "Confirm",
  message = "Are you sure?",
  confirmpopupmessage = "Are you sure you want to cancel this post?",
  onConfirm,
  onCancel,
  confirmText = "Confirm",
  cancelText = "Cancel",
  showConfirmModel = false,
}) {
  const profile = useSelector(({ profile: { profiledata } }) => profiledata);
  const confirmpopup = (profile?.settings?.max_cancelation > 0) && (profile?.settings?.total_cancelation >= profile?.settings?.max_cancelation) || false;

  return (
    <Modal className="popupmodal confirm-modal" isOpen={isOpen} toggle={toggle} style={{ zIndex: 9999, }}>
      <div>
        <button onClick={toggle} className="btn close-button">
          <img
            src={`${CloudStorage.cloudurl}/Assets/Images/common/close-icon.svg`}
            alt="close"
          />
        </button>
        {/* <p>message  {JSON.stringify(message)}</p>
        <p>confirmpopupmessage  {JSON.stringify(confirmpopupmessage)}</p>
    */}

        {/* <p>confirmpopup  {JSON.stringify(confirmpopup)}</p>
        <p>showConfirmModel  {JSON.stringify(showConfirmModel)}</p> */}
        <ModalBody>
          <h4 style={{ whiteSpace: "pre-wrap" }}>{title}</h4>
          <p style={{ whiteSpace: "pre-wrap" }}>{showConfirmModel ? (confirmpopup ? confirmpopupmessage : message) : message}</p>
        </ModalBody>

        <div className="modal-footer mt-3">

          {(showConfirmModel && confirmpopup) ? <></> : (
            <button
              className="btn"
              onClick={() => {
                onConfirm?.();
                toggle();
              }}
            >
              {confirmText}
            </button>
          )}
          <div style={{ padding: 5 }} />
          <button
            className="btn no"
            style={{ background: '#fff', color: '#000', border: '1px solid' }}
            onClick={() => {
              onCancel?.();
              toggle();
            }}
          >
            {cancelText}
          </button>
        </div>
      </div>
    </Modal>
  );
}
